import { Heading, useEntity } from 'components';
import type { ReactElement } from 'react';
import type { Ticket } from 'modules/support/types';
import { TickStateTag } from 'modules/support/SupportStateTag';

export function Header(): ReactElement {
  const {
    item: { id, state, title },
  } = useEntity<Ticket>();
  return (
    <Heading>
      <h1>
        <span className="text-muted">#{id}</span>
        {title}
        <TickStateTag state={state} ml="2" />
      </h1>
    </Heading>
  );
}
